module.exports = __webpack_public_path__ + "img/Flag_of_Niue.80b28a64.svg";